var _rect, _rect2, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGreyReplace(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 3,
    width: 5,
    height: 5,
    rx: 1,
    stroke: "#A6A6B2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 12.5,
    y: 13,
    width: 5,
    height: 5,
    rx: 1,
    stroke: "#A6A6B2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4997 9.66667C16.4997 10.219 16.9474 10.6667 17.4997 10.6667C18.052 10.6667 18.4997 10.219 18.4997 9.66667H16.4997ZM10.833 5.5V4.5C10.4285 4.5 10.0639 4.74364 9.90913 5.11732C9.75435 5.49099 9.8399 5.92111 10.1259 6.20711L10.833 5.5ZM12.6259 8.70711C13.0164 9.09763 13.6496 9.09763 14.0401 8.70711C14.4306 8.31658 14.4306 7.68342 14.0401 7.29289L12.6259 8.70711ZM14.0401 3.70711C14.4306 3.31658 14.4306 2.68342 14.0401 2.29289C13.6496 1.90237 13.0164 1.90237 12.6259 2.29289L14.0401 3.70711ZM10.1259 4.79289C9.73538 5.18342 9.73538 5.81658 10.1259 6.20711C10.5164 6.59763 11.1496 6.59763 11.5401 6.20711L10.1259 4.79289ZM18.4997 9.66667V7.16667H16.4997V9.66667H18.4997ZM18.4997 7.16667C18.4997 5.69391 17.3058 4.5 15.833 4.5V6.5C16.2012 6.5 16.4997 6.79848 16.4997 7.16667H18.4997ZM15.833 4.5H10.833V6.5H15.833V4.5ZM10.1259 6.20711L12.6259 8.70711L14.0401 7.29289L11.5401 4.79289L10.1259 6.20711ZM12.6259 2.29289L10.1259 4.79289L11.5401 6.20711L14.0401 3.70711L12.6259 2.29289Z",
    fill: "#A6A6B2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 11.332C3.5 10.7797 3.05228 10.332 2.5 10.332C1.94772 10.332 1.5 10.7797 1.5 11.332H3.5ZM9.16667 15.4987V16.4987C9.57113 16.4987 9.93577 16.2551 10.0905 15.8814C10.2453 15.5077 10.1598 15.0776 9.87377 14.7916L9.16667 15.4987ZM7.37377 12.2916C6.98325 11.9011 6.35008 11.9011 5.95956 12.2916C5.56904 12.6821 5.56904 13.3153 5.95956 13.7058L7.37377 12.2916ZM5.95956 17.2916C5.56904 17.6821 5.56904 18.3153 5.95956 18.7058C6.35008 19.0963 6.98325 19.0963 7.37377 18.7058L5.95956 17.2916ZM9.87377 16.2058C10.2643 15.8153 10.2643 15.1821 9.87377 14.7916C9.48325 14.4011 8.85008 14.4011 8.45956 14.7916L9.87377 16.2058ZM1.5 11.332V13.832H3.5V11.332H1.5ZM1.5 13.832C1.5 15.3048 2.69391 16.4987 4.16667 16.4987V14.4987C3.79848 14.4987 3.5 14.2002 3.5 13.832H1.5ZM4.16667 16.4987H9.16667V14.4987H4.16667V16.4987ZM9.87377 14.7916L7.37377 12.2916L5.95956 13.7058L8.45956 16.2058L9.87377 14.7916ZM7.37377 18.7058L9.87377 16.2058L8.45956 14.7916L5.95956 17.2916L7.37377 18.7058Z",
    fill: "#A6A6B2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreyReplace);
export default __webpack_public_path__ + "static/media/GreyReplace.e99dcf8274f5fdd7393ae0d18e4e81f3.svg";
export { ForwardRef as ReactComponent };